import { dialog } from "../../../nq-component";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function DialogInterviewForm({
  handleAssign,
  positions,
  application,
  navigate,
  handleChange,
}) {
  // const [selectedPosition, setSelectedPosition] = useState("");

  function _handleAssign(event) {
    event.preventDefault();

    // if (!selectedPosition) {
    //   alert("Please select a position before submitting.");
    //   return;
    // }

    // handleAssign(selectedPosition);
  }

  // function submit() {
  //   navigate(`/interview/form/walkIn/${application?.id}`);
  // }

  return (
    <>
      <form onSubmit={_handleAssign}>
        <div className="p-4">
          <div className="d-flex align-items-center gap-3">
            <div className="align-self-start">
              <i
                className="bi bi-briefcase fs-2 px-2 py-1 rounded"
                style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
              ></i>
            </div>
            <div className="d-flex flex-column container-fluid">
              <h5 className="fw-bold mt-2" style={{ color: "#D18237" }}>
                Interview Form
              </h5>
              <div className="me-1">
                <p className="mt-4">
                  <span className="fw-bold">Current Position: </span>
                  <span>{application?.positionApplied}</span>
                </p>
                <div className="ds-flex flex-column">
                  <label className="fw-bold">Position Desired:</label>
                  <select
                    className="form-control bg-light-subtle p-2"
                    name="positionTitle"
                    onChange={handleChange}
                  >
                    <option value="" selected disabled>
                      Select
                    </option>
                    {positions.map((position, index) => (
                      <option key={index} value={position?.positionTitle}>
                        {position?.positionTitle}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center mb-3">
          <button
            type="button"
            className="btn"
            style={{ backgroundColor: "#e8ecf3" }}
            onClick={() => dialog.close()}
          >
            Cancel
          </button>

          <button
            type="submit"
            className="btn text-white ms-2"
            style={{ backgroundColor: "#D18237" }}
            onClick={navigate}
          >
            Submit
          </button>
        </div>
      </form>
    </>
  );
}

export default DialogInterviewForm;
